@if (label) {
  <ion-label>
    {{ label | transloco }}
  </ion-label>
}
<ion-textarea
  [rows]="rows"
  [cols]="cols"
  placeholder="{{ placeholder | transloco }}"
  [formControl]="control"
  [class.readonly]="readonly"
  [class.error]="hasErrors"
  [maxlength]="maxLength"
  [readonly]="readonly"
  [autoGrow]="autoGrow"
  [counter]="counter"
  mode="ios"
  [class.counter-padding]="counter"
></ion-textarea>
@if (hasErrors) {
  <div class="error-wrapper">
    <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value"> </c-validation-error>
  </div>
}
